var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"margin-top":"5%"},attrs:{"max-width":"100%","fluid":""}},[_c('CRUDFuncionarios')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }